import React, { useEffect, useState } from 'react'
import './ImagePreviewWrapper.css'

export enum ImagePreviewWrapperSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

interface IImagePreviewWrapperProps {
  archived?: boolean
  image: string | null
  imgPreview?: string | null
  size?: ImagePreviewWrapperSizeEnum
  onClick: () => void
  isReportPageItem?: boolean
  className?: string
}

export const ImagePreviewWrapper: React.FC<IImagePreviewWrapperProps> =
  React.memo(
    ({
      archived,
      image,
      imgPreview,
      size,
      onClick,
      isReportPageItem,
      className,
    }) => {
      const [isBroken, setIsBroken] = useState(!image)
      useEffect(() => {
        setIsBroken(!image)
      }, [image, imgPreview])

      const previewClass = `image-preview-${size?.toLowerCase() || 'medium'}`
      const containerClassName = [
        'photo-preview-block',
        className,
        archived ? 'delete-item' : '',
      ]
        .filter(Boolean)
        .join(' ')

      const onReportPageImageClick = isReportPageItem ? onClick : undefined

      return (
        <div className={`${containerClassName} ${previewClass}`}>
          {!!image && !isBroken ? (
            <>
              <img
                className={` ${previewClass}`}
                src={imgPreview ?? image}
                loading="lazy"
                alt=""
                onError={() => setIsBroken(true)}
                onClick={onClick}
              />
              <div className="loupe-block" onClick={onClick}>
                <i className="an-ico an-ico-search" />
              </div>
            </>
          ) : (
            <div
              className={`photo-cover ${previewClass}`}
              onClick={onReportPageImageClick}
            >
              <div className="photo-cover-circle">
                <i
                  className={`an-ico an-ico-${
                    isBroken ? 'photo-error' : 'photo-add'
                  }`}
                />
              </div>
            </div>
          )}
        </div>
      )
    },
  )
